var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterieurVoiture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3001.78 3000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:url(#D\xE9grad\xE9_sans_nom_82);}.cls-3{fill:#3d3e42;}.cls-4{fill:url(#D\xE9grad\xE9_sans_nom_15);}.cls-5{clip-path:url(#clip-path);}.cls-6{fill:#4f6478;}.cls-7{clip-path:url(#clip-path-2);}.cls-8{fill:#64cce3;}.cls-9{fill:#a7dff3;}.cls-10{clip-path:url(#clip-path-3);}.cls-11{clip-path:url(#clip-path-4);}.cls-12{fill:#bbd5ea;opacity:0.19;}.cls-13{fill:#394b5b;}.cls-14{clip-path:url(#clip-path-5);}.cls-15{clip-path:url(#clip-path-6);}.cls-16{clip-path:url(#clip-path-7);}.cls-17{clip-path:url(#clip-path-8);}.cls-18{clip-path:url(#clip-path-9);}.cls-19{clip-path:url(#clip-path-10);}.cls-20{clip-path:url(#clip-path-11);}.cls-21{clip-path:url(#clip-path-12);}.cls-22{clip-path:url(#clip-path-13);}.cls-23{clip-path:url(#clip-path-14);}.cls-24{clip-path:url(#clip-path-15);}.cls-25{clip-path:url(#clip-path-16);}.cls-26{clip-path:url(#clip-path-17);}.cls-27{clip-path:url(#clip-path-18);}.cls-28{fill:#77a06a;}.cls-29{clip-path:url(#clip-path-19);}.cls-30{fill:#bcc0c4;}.cls-31{fill:#d2d5d8;}.cls-32{fill:#d9dce8;}.cls-33{fill:#1a1a1c;}.cls-34{fill:#a4aaa2;}.cls-35{fill:#95ce80;}.cls-36{fill:#232728;}.cls-37{fill:#b8b8b8;}.cls-38{fill:#686d6d;}.cls-39{fill:#bddff2;opacity:0.32;}.cls-40{fill:url(#D\xE9grad\xE9_sans_nom_49);}.cls-41{clip-path:url(#clip-path-20);}.cls-42{fill:#272b2e;}.cls-43{fill:#303335;}.cls-44{clip-path:url(#clip-path-21);}.cls-45{fill:url(#D\xE9grad\xE9_sans_nom_96);}.cls-46{fill:url(#D\xE9grad\xE9_sans_nom_101);}.cls-47{fill:url(#D\xE9grad\xE9_sans_nom_36);}.cls-48{fill:url(#D\xE9grad\xE9_sans_nom_36-2);}.cls-49{fill:#c7ced3;stroke:#272b2e;stroke-miterlimit:10;stroke-width:10px;}.cls-50{clip-path:url(#clip-path-22);}.cls-51{fill:#55595b;}.cls-52{fill:#97675e;}.cls-53{fill:#173856;}.cls-54{fill:#20456e;}.cls-55{fill:#82cec4;}.cls-56{fill:#282b2e;}.cls-57{fill:url(#D\xE9grad\xE9_sans_nom_31);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_82",
    x1: 347.41,
    y1: 1423.97,
    x2: 2714,
    y2: 1423.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d3236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#31363b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#40444b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#494c55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#4c4f58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_15",
    x1: 1611.28,
    y1: 784,
    x2: 1611.28,
    y2: 127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#99bed4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66abff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1523.3 722 1227 728.45 1227.33 858 1564.21 857 1523.3 722"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1217 778 1217 741.66 1559 741.66 1559 774 1217 778"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1217 804 1217 785.66 1559 785.66 1559 801.98 1217 804"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1217 831 1217 812.66 1559 812.66 1559 828.98 1217 831"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1518.06 724.45 1691 638 1689 590 1518 695.89 1518.06 724.45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1518 780.12 1892.06 640.53 1828.42 621.8 1518 748.24 1518 780.12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1756 849 1736 545 2001 364 2225 364 2248.55 826.71 1756 849"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1740 611 2006 441 2004 391 1737 566 1740 611"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1748 727 2012 590 2010 480 1743 655 1748 727"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2038.15 529.2 2707 263 2532 237 2038 462.1 2038.15 529.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2038 660 2949 332 2794 288 2038 585.1 2038 660"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1233.94 774.45 1061 688 1063 640 1234 745.89 1233.94 774.45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1234 830.12 859.94 690.53 923.58 671.8 1234 798.24 1234 830.12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "996 899 1016 595 751 414 527 414 503.45 876.71 996 899"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1012 661 746 491 748 441 1015 616 1012 661"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1004 777 740 640 742 530 1009 705 1004 777"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "713.85 579.2 45 313 220 287 714 512.1 713.85 579.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "714 710 -197 382 -42 338 714 635.1 714 710"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-1,1022s640,4,690,0,134-16,203-37,511-129,511-129l108-3s513,96,563,100,248,41,399,46,527,11,527,11V944s-293,37-445,9-928-100-928-100l-254,3L563,920s-117,16-204,12S-1,929-1,929Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_49",
    x1: 2202.99,
    y1: 1886.68,
    x2: 2202.99,
    y2: 1571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2c3030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2f3334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#383c3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#3f4346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414548"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1205,1691s17,199,22,224,10,109,62,179,93,102,220,100,151-26,209-96,81-399,81-399Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M401,1541s-42-22-50-79-7-114,50-153,79-30,140-41,191-53,295-55,222,2,302,48c15,10,36,11,59,5,36-15,23-57,59-75,16-9,135-47,252-47s237,22,250,28,21,22,26,33,14,33,18,41,4,15,12,17,766,23,795,33,47,22,57,33,48,55,48,96c0,18.44-3,52-8,63s-13,20-17,32-19,23-23,27-47,51-76,56-531-8-602,15-114,76-189,81-557,8-583,0-21-16-26-32-6-43-25-64Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_96",
    x1: 1530.71,
    y1: 1703.94,
    x2: 1530.71,
    y2: 1144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d3236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#31363b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#40444b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#494c55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#4c4f58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72757d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_101",
    x1: 1506.19,
    y1: 1641.44,
    x2: 1506.19,
    y2: 1128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d3236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#31363b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#40444b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#494c55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#4c4f58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a5e69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_36",
    x1: 2139,
    y1: 3000,
    x2: 2139,
    y2: 2501.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c3030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3d4146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#484b53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c4f58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_36-2",
    x1: 585.7,
    x2: 585.7,
    y2: 2550.51,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_36"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1091.5,1426.5c-5-10-99-211-328-200-226.62,10.89-338,219-338,219s-71,99-59,254c8.17,105.49,70,201,165,245s276,70,443-77S1145.5,1530.5,1091.5,1426.5ZM763.05,1296.36c192-9.14,270.86,158,275,166.3,10.22,19.52,15.74,44.48,17,72.41-12.92,7.08-30.94,15.91-43.07,17.93-18,3-55-22-55-22s-76-49-165-56-162,25-175,30-82,39-110,37-33-13-39-30c-1.92-5.43.76-14.63,5.29-24.64,3.86-5.83,6.33-8.91,6.33-8.91S573,1305.41,763.05,1296.36Zm-332,399.32c3.62-19,17-29.57,21.91-31.68,7-3,67-25,88,47s83,89,96,103c20.39,22,14,72,6,83-3.18,4.38-8.58,8.59-13.93,12.09a273.53,273.53,0,0,1-45.57-15.59C535.48,1872.09,447.64,1793.26,431.09,1695.68ZM933,1828c-55.81,44.08-110.1,69.08-160.27,80.93-10.32-20.33-40-107,23.27-135.93,81-37,111-91,120-103s66-37,98-33c14.74,1.84,3,51,10,59.66C1003,1748,972,1795.64,933,1828Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_31",
    x1: 416.8,
    y1: 1560.32,
    x2: 416.8,
    y2: 1039.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97675e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#90635b",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#624a47",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#413839",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#2e2e30",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282b2e"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "int\xE9rieur voiture fond d&amp;apos;\xE9cran") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_5",
    "data-name": "Calque 5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1.78 1446 680.78 1284 2694.78 1351 3001.78 1558 3001.78 944 1590.45 856 1363.78 859 296.51 958.03 1.78 979 1.78 1446"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "825.78 771 221.78 287 1294.78 127 1971.78 148 3000.78 310.42 2039.78 784 825.78 771"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1524.75 722 1228.45 728.45 1228.78 858 1565.66 857 1524.75 722"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1218.78 778 1218.78 741.66 1560.78 741.66 1560.78 774 1218.78 778"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1246.78,
    y: 734,
    width: 21,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1274.78,
    y: 734,
    width: 9,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1347.78,
    y: 733,
    width: 69,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1421.78,
    y: 733,
    width: 6,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1501.78,
    y: 729,
    width: 16,
    height: 53
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1218.78 804 1218.78 785.66 1560.78 785.66 1560.78 801.98 1218.78 804"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1246.78,
    y: 781.79,
    width: 21,
    height: 26.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1274.78,
    y: 781.79,
    width: 9,
    height: 26.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1347.78,
    y: 781.29,
    width: 69,
    height: 26.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1421.78,
    y: 781.29,
    width: 6,
    height: 26.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1501.78,
    y: 779.27,
    width: 16,
    height: 26.75
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1218.78 831 1218.78 812.66 1560.78 812.66 1560.78 828.98 1218.78 831"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1246.78,
    y: 808.79,
    width: 21,
    height: 26.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1274.78,
    y: 808.79,
    width: 9,
    height: 26.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1347.78,
    y: 808.29,
    width: 69,
    height: 26.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1421.78,
    y: 808.29,
    width: 6,
    height: 26.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1501.78,
    y: 806.27,
    width: 16,
    height: 26.75
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1207.78,
    y: 718,
    width: 332,
    height: 146
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1519.78 686.91 1519.78 858 1696.78 854 1690.78 578 1519.78 686.91"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1519.84 724.45 1692.78 638 1690.78 590 1519.78 695.89 1519.84 724.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1530.04 722.24 1538.67 683.09 1552.21 676.7 1541.13 722.24 1530.04 722.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1569.78 702 1580.49 651.51 1607.79 637.43 1595.4 687.93 1569.78 702"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1641.78 668 1646.78 612 1682.78 590 1683.01 647.46 1641.78 668"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1602.58 692.21 1614.78 635 1619.78 631 1607.65 690.75 1602.58 692.21"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1519.78 784.37 1907.39 642.65 1827.32 607.76 1519.78 748.24 1519.78 784.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1518.13 780.97 1526.76 741.82 1540.31 735.43 1529.22 780.97 1518.13 780.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1558.64 766.68 1567.36 723.8 1594.65 709.71 1582.26 760.21 1558.64 766.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1639.26 743.94 1647.89 695 1699.21 669.47 1692.23 721.39 1639.26 743.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1771.07 687.77 1778.05 638.4 1815.41 621.8 1808.43 673.72 1771.07 687.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1588.62 758.17 1597.33 715.28 1606.41 710.75 1593.69 756.71 1588.62 758.17"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1690.78 578 1739.95 578 1761.14 849 1696.78 853 1690.78 578"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1757.78 849 1737.78 545 2002.78 364 2226.78 364 2250.33 826.71 1757.78 849"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1735.78 615 2006.78 442 2006.78 390 1735.78 568.19 1735.78 615"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1762.78 600 1766.78 546 1775.78 539 1770.78 595 1762.78 600"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1866.78 536 1875.78 471 1888.78 463 1881.78 527 1866.78 536"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1948.78 483 1949.78 424 1993.61 396.94 1995.78 453 1948.78 483"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1892.78 519 1897.78 458 1903.78 455 1897.78 517 1892.78 519"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1750.78 744 2018.78 597 2012.78 479 1741.78 657.19 1750.78 744"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1753.78 752 1761.78 640 1770.78 633 1761.78 747 1753.78 752"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1845.78 704 1863.78 566 1876.78 558 1860.78 695 1845.78 704"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1952.78 634 1950.78 513 1996.61 485.94 1999.78 604 1952.78 634"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1871.78 687 1885.78 553 1891.78 550 1876.78 685 1871.78 687"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2002.78 364 2025.78 858 2250.78 827 2226.78 357 2002.78 364"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "2039.78 441 2039.78 843 3001.78 824.12 3001.78 15 2039.78 441"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2039.93 529.2 2708.78 263 2510.78 234 2039.78 462.1 2039.93 529.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "2064.78 524 2085.78 432 2118.78 417 2091.78 524 2064.78 524"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "2166.43 484.43 2187.65 383.66 2254.12 350.57 2223.95 469.22 2166.43 484.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "2366.78 406 2387.78 291 2512.78 231 2495.78 353 2366.78 406"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "2241.43 453.43 2262.65 352.66 2284.78 342 2253.78 450 2241.43 453.43"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2039.78 670 2983.78 337 2788.78 255 2039.78 585.1 2039.78 670"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "2035.78 662 2056.78 570 2089.78 555 2062.78 662 2035.78 662"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "2134.43 628.43 2155.65 527.66 2222.12 494.57 2191.95 613.22 2134.43 628.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "2330.78 575 2351.78 460 2476.78 400 2459.78 522 2330.78 575"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "2651.78 443 2668.78 327 2759.78 288 2742.78 410 2651.78 443"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "2207.43 608.43 2228.65 507.66 2250.78 497 2219.78 605 2207.43 608.43"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1235.78 736.91 1235.78 908 1058.78 904 1064.78 628 1235.78 736.91"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1235.71 774.45 1062.78 688 1064.78 640 1235.78 745.89 1235.71 774.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1225.51 772.24 1216.89 733.09 1203.34 726.7 1214.43 772.24 1225.51 772.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1185.78 752 1175.06 701.51 1147.77 687.43 1160.15 737.93 1185.78 752"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1113.78 718 1108.78 662 1072.78 640 1072.54 697.46 1113.78 718"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1152.98 742.21 1140.78 685 1135.78 681 1147.91 740.75 1152.98 742.21"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1235.78 834.37 848.17 692.65 928.24 657.76 1235.78 798.24 1235.78 834.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1237.42 830.97 1228.8 791.82 1215.25 785.43 1226.33 830.97 1237.42 830.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1196.91 816.68 1188.2 773.8 1160.91 759.71 1173.29 810.21 1196.91 816.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1116.29 793.94 1107.67 745 1056.34 719.47 1063.33 771.39 1116.29 793.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "984.49 737.77 977.51 688.4 940.14 671.8 947.12 723.72 984.49 737.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1166.94 808.17 1158.22 765.28 1149.14 760.75 1161.87 806.71 1166.94 808.17"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1064.78 628 1015.61 628 994.41 899 1058.78 903 1064.78 628"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "997.78 899 1017.78 595 752.78 414 528.78 414 505.23 876.71 997.78 899"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1019.78 665 748.78 492 748.78 440 1019.78 618.19 1019.78 665"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "992.78 650 988.78 596 979.78 589 984.78 645 992.78 650"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "888.78 586 879.78 521 866.78 513 873.78 577 888.78 586"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "806.78 533 805.78 474 761.94 446.94 759.78 503 806.78 533"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "862.78 569 857.78 508 851.78 505 857.78 567 862.78 569"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1004.78 794 736.78 647 742.78 529 1013.78 707.19 1004.78 794"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1001.78 802 993.78 690 984.78 683 993.78 797 1001.78 802"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "909.78 754 891.78 616 878.78 608 894.78 745 909.78 754"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "802.78 684 804.78 563 758.94 535.94 755.78 654 802.78 684"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "883.78 737 869.78 603 863.78 600 878.78 735 883.78 737"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "752.78 414 729.78 908 504.78 877 528.78 407 752.78 414"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "715.78 491 715.78 893 1.78 879 1.78 173 715.78 491"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "715.62 579.2 46.78 313 244.78 284 715.78 512.1 715.62 579.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "690.78 574 669.78 482 636.78 467 663.78 574 690.78 574"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "589.12 534.43 567.9 433.66 501.43 400.57 531.6 519.22 589.12 534.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "388.78 456 367.78 341 242.78 281 259.78 403 388.78 456"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "514.12 503.43 492.9 402.66 470.78 392 501.78 500 514.12 503.43"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "715.78 720 1.78 456 1.78 315 715.78 635.1 715.78 720"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "719.78 712 698.78 620 665.78 605 692.78 712 719.78 712"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "621.12 678.43 599.9 577.66 533.43 544.57 563.6 663.22 621.12 678.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "424.78 625 403.78 510 278.78 450 295.78 572 424.78 625"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "103.78 493 86.78 377 1.78 342 12.78 460 103.78 493"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "548.12 658.43 526.9 557.66 504.78 547 535.78 655 548.12 658.43"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1627,853s20-3,27-4,1025-38,1025-38h321V962l-403.71,18Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1373,856S612,960,566,958,0,958,0,958V842.87L344.16,856Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M0,1022s640,4,690,0,134-16,203-37,504-121,504-121h134s494,85,544,89,248,41,399,46,526,11,526,11V944s-292,37-444,9-928-100-928-100l-254,3L564,920s-117,16-204,12S0,929,0,929Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M0,1040v-38s701-11,734-14,663-124,663-124h134s859.21,117.3,943,121,526,3,526,3v36Z",
    transform: "translate(1.78)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "passage_pi\\xE9ton",
    "data-name": "passage pi\\xE9ton"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "964.78 985 1055.78 961 1092.78 961 1019.78 985 964.78 985"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "1073.78 985 1142.78 961 1176.78 961 1128.78 985 1073.78 985"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "1172.78 985 1215.78 985 1255.78 961 1223.78 961 1172.78 985"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "1267.78 985 1305.78 961 1338.78 961 1311.78 985 1267.78 985"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "1351.78 985 1379.78 961 1409.78 961 1394.78 985 1351.78 985"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "1441.78 985 1454.78 961 1480.78 961 1479.78 985 1441.78 985"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "1542.78 985 1530.78 961 1562.78 961 1583.78 985 1542.78 985"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "1635.78 985 1612.78 961 1642.78 961 1681.78 985 1635.78 985"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "1690.78 961 1735.78 985 1776.78 985 1724.78 961 1690.78 961"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1823,985s-61-24-60-24h40l64,24Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "1835.78 961 1910.78 985 1949.78 985 1865.78 961 1835.78 961"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1908,961l91,24h39c-3,0-97-24-97-24Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "1992.78 961 2100.78 985 2157.78 985 2043.78 961 1992.78 961"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "1461.78 958 1471.78 958 1485.78 868 1479.78 868 1461.78 958"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "1196.78 955 1208.78 955 1461.78 868 1459.78 868 1196.78 955"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "1519.78 869 1722.78 958 1733.78 958 1520.78 869 1519.78 869"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "826.15 972.35 825.78 897 835.78 897 835.78 970.72 826.15 972.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "756.15 985.35 755.78 904 765.78 904 765.78 983.59 756.15 985.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "2191.4 957.35 2191.78 889 2181.78 889 2181.78 955.87 2191.4 957.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "2261.4 970.35 2261.78 889 2251.78 889 2251.78 968.59 2261.4 970.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1702.71,879.71s1.91-51.87,2.87-64.1,1.92-30,1.92-30-8.15-4.07-9.11-1.11-3.83,57.07-3.83,61.51v33.72Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1688.33,800.64s-34-9.52-42.64-34.51-5.27-40.06,2.39-50.37,20.13-9.91,24-14.28,21.08-21,35.46-15.86,55.1.79,63.25,36.88-14.38,66.64-37.86,72.19S1708,804.21,1688.33,800.64Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1983.88,922s3.29-114.21,4.94-141.13,3.3-66.07,3.3-66.07-14-9-15.66-2.45-6.6,125.63-6.6,135.42V922Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1959.14,755.59s-58.53-19.58-73.37-71-9.07-82.39,4.12-103.6,34.63-20.39,41.22-29.36,36.28-43.24,61-32.63,94.81,1.63,108.83,75.86-24.74,137-65.13,148.47S1993,762.93,1959.14,755.59Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M2103,939s4-140,6-173,4-81,4-81-17-11-19-3-8,154-8,166v91Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M2073,735s-71-24-89-87-11-101,5-127,42-25,50-36,44-53,74-40,115,2,132,93-30,168-79,182S2114,744,2073,735Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1855.2,898s2.66-83,4-102.61,2.66-48,2.66-48-11.3-6.53-12.63-1.78-5.32,91.35-5.32,98.47v54Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1835.25,777s-47.21-14.24-59.18-51.61-7.31-59.91,3.33-75.33,27.93-14.83,33.25-21.35,29.25-31.44,49.2-23.73,76.47,1.19,87.78,55.16-20,99.66-52.53,108S1862.52,782.34,1835.25,777Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1935.15,914s3.23-101.8,4.84-125.79,3.23-58.9,3.23-58.9-13.71-8-15.33-2.18-6.45,112-6.45,120.7V914Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1911,765.67s-57.27-17.46-71.79-63.27-8.87-73.44,4-92.34,33.88-18.18,40.33-26.18,35.49-38.54,59.69-29.08,92.75,1.45,106.47,67.62-24.2,122.16-63.72,132.34S1944,772.21,1911,765.67Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1742.3,886s1.48-50.09,2.22-61.9,1.48-29,1.48-29-6.3-3.94-7-1.08-3,55.11-3,59.4V886Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1722,800.14s-34.78-10.68-43.59-38.71-5.39-44.94,2.45-56.51,20.57-11.13,24.49-16,21.54-23.59,36.24-17.8,56.32.89,64.65,41.38-14.7,74.76-38.69,81S1742,804.15,1722,800.14Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1790.54,895s2.37-71.34,3.56-88.16,2.38-41.28,2.38-41.28-10.1-5.6-11.29-1.53-4.75,78.48-4.75,84.6V895Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1772.71,791s-42.17-12.23-52.87-44.33-6.53-51.47,3-64.72,25-12.74,29.71-18.35,26.13-27,44-20.38,68.31,1,78.41,47.39-17.82,85.61-46.93,92.75S1797.07,795.63,1772.71,791Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1655.21,871.56s1.58-42.32,2.37-52.29,1.58-24.49,1.58-24.49-6.71-3.32-7.51-.9-3.16,46.55-3.16,50.17v27.51Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1643.36,796.82s-28-7.76-35.16-28.15-4.34-32.68,2-41.09,16.59-8.09,19.75-11.65,17.38-17.15,29.23-12.94,45.43.65,52.14,30.09-11.85,54.36-31.2,58.89S1659.56,799.74,1643.36,796.82Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1584.85,864.19s1.64-39.67,2.47-49,1.64-23,1.64-23-7-3.11-7.82-.85-3.3,43.64-3.3,47v25.79Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1572.49,818.91s-29.24-6.8-36.66-24.65-4.53-28.63,2.06-36,17.3-7.09,20.6-10.2,18.12-15,30.47-11.34,47.37.57,54.37,26.35-12.36,47.61-32.54,51.58S1589.38,821.46,1572.49,818.91Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1618.88,869s1.27-38.31,1.91-47.34,1.27-22.16,1.27-22.16-5.41-3-6-.83-2.55,42.15-2.55,45.43V869Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1597.1,815s-29.89-7.63-37.47-27.66-4.63-32.11,2.1-40.37,17.68-8,21-11.45,18.53-16.85,31.16-12.71,48.41.63,55.57,29.56-12.63,53.41-33.26,57.86S1614.36,817.84,1597.1,815Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1544,858s1.36-32.37,2-40,1.35-18.72,1.35-18.72-5.77-2.54-6.45-.69-2.71,35.6-2.71,38.37v21Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1533.83,823.33s-24.11-5.55-30.22-20.11-3.73-23.35,1.7-29.36,14.26-5.78,17-8.33,14.94-12.25,25.12-9.24,39,.46,44.83,21.5-10.19,38.83-26.83,42.07S1547.75,825.41,1533.83,823.33Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1246.2,886.05s-4.62-51.7-6.21-63.86-3.48-29.88-3.48-29.88,7.93-4.49,9-1.58,6.8,56.78,7,61.23l1.75,33.67Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1256.44,806.34s33.48-11.28,40.79-36.68,3.18-40.28-5-50.18-20.61-8.85-24.66-13-22.15-19.9-36.24-14-55,3.66-61.24,40.13,17.82,65.8,41.56,70.12S1237,810.93,1256.44,806.34Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M967.61,942.92S958.37,829,955.32,802.24s-6.73-65.81-6.73-65.81,13.53-9.69,15.52-3.26,13.12,125.11,13.63,134.89l3.87,74.13Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M983.65,775.44s57.43-22.6,69.58-74.69S1058,618,1043.72,597.5s-35.64-18.56-42.7-27.18S962.55,529,938.4,540.91s-94.6,6.56-104.73,81.43,31.83,135.57,72.77,144.87S950.27,784.53,983.65,775.44Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M858.77,958.05s-11.29-139.6-15-172.45-8.21-80.69-8.21-80.69,16.4-11.87,18.82-4,16,153.37,16.63,165.36l4.73,90.87Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M878.11,752.76s69.65-27.66,84.35-91.51,5.73-101.44-11.61-126.57-43.24-22.78-51.8-33.35-46.7-50.64-76-36.09-114.74,8-127,99.74,38.7,166.21,88.36,177.64S837.63,763.89,878.11,752.76Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1094.86,912.26s-7-82.8-9.33-102.27-5.15-47.85-5.15-47.85,10.95-7.1,12.52-2.43,10.07,90.95,10.44,98l2.81,53.91Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1108.48,790.38s46.41-16.68,56.42-54.62,4.18-60.21-7.24-75.06-28.67-13.35-34.32-19.59S1092.49,611.24,1073,620s-76.31,5.16-84.79,59.66,25.11,98.47,58.08,105.07S1081.53,797.13,1108.48,790.38Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1015.85,932.39S1007.33,830.9,1004.47,807s-6.29-58.65-6.29-58.65,13.28-8.7,15.19-3,12.27,111.49,12.73,120.2l3.44,66.08Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1032.29,783s56.28-20.41,68.4-66.91,5-73.8-8.84-92-34.77-16.39-41.63-24-37.45-36.64-61.12-25.94-92.56,6.28-102.8,73.07S916.82,767.9,956.82,776,999.61,791.26,1032.29,783Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1207,894.39s-4.09-49.95-5.44-61.7-3-28.86-3-28.86,6.08-4.26,7-1.44,5.83,54.87,6,59.16l1.7,32.52Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1222.83,807.59s34.17-12.47,41.52-40.93,3-45.16-5.39-56.3-21.12-10-25.29-14.73-22.75-22.43-37.12-15.89-56.2,3.83-62.41,44.7,18.57,73.89,42.86,78.86S1203,812.64,1222.83,807.59Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1159.28,905.89s-6.08-71.12-8.15-87.85-4.52-41.1-4.52-41.1,9.8-6.12,11.2-2.12,8.83,78.13,9.14,84.24l2.42,46.31Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1171.67,801.15s41.48-14.41,50.49-47,3.85-51.74-6.33-64.48-25.58-11.42-30.62-16.77-27.51-25.61-45-18.07-68.17,4.58-75.85,51.41,22.26,84.57,51.7,90.18S1147.58,807,1171.67,801.15Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1293.2,875.44s-3.78-42.18-5.08-52.1-2.86-24.37-2.86-24.37,6.54-3.67,7.45-1.29,5.58,46.32,5.77,49.94l1.43,27.47Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1301.15,800.19s27.6-9.22,33.64-29.94,2.64-32.87-4.11-40.94-17-7.21-20.33-10.6-18.25-16.22-29.86-11.4-45.34,3-50.51,32.76,14.66,53.67,34.23,57.18S1285.13,803.94,1301.15,800.19Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1363.09,864.42s-3.71-39.54-5-48.83-2.84-22.84-2.84-22.84,6.83-3.48,7.77-1.25,5.56,43.41,5.74,46.8l1.34,25.75Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1373.07,818.56s28.85-8.32,35.33-26.53,3-28.82-3.93-35.84-17.65-6.17-21.1-9.11-18.88-14.06-31-9.74-47.27,3-52.92,29.15,14.82,46.9,35.18,49.81S1356.34,822,1373.07,818.56Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1329.36,871s-3.27-38.19-4.38-47.17-2.42-22.07-2.42-22.07,5.25-3.29,6-1.14,4.73,41.95,4.9,45.23l1.3,24.87Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1348.3,815.91s29.45-9.17,36-29.57,3-32.31-4.2-40.21-18.07-7-21.62-10.33-19.37-15.87-31.77-11.08-48.32,3.15-54,32.42,15.4,52.68,36.23,56.05S1331.21,819.67,1348.3,815.91Z",
    transform: "translate(1.78)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M0,2721l382-778,85-518,2154,109s15,487,27,491,352,265,352,265v710H0Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "522.78 1271 468.78 1296 463.78 1204 1.78 680 1.78 441 652.78 1226 2393.78 1235 3001.78 466 3001.78 731 2600.78 1295 2471.78 1267 522.78 1271"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1024,1223.12l229-.12,524-31.73S2163,1223,2216,1223s157.13,1.62,176,12c20,11,23,23,59,29s81,9,105,13,65,30,65,30l-1544,44Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2663,1318l337,82v908s-316-169-325-250S2663,1318,2663,1318Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M365,1322,0,1446-1,2570.32S389,2024,398,1943,365,1322,365,1322Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2556,1979s-3-661,23-753,135-206,135-206l286-289V890s-314,307-318,377c-2.37,41.47-25,456-7,751,2.67,43.74,295,231,325,272v141s-229-178-286-221S2579,2098,2556,1979Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M493,1923s0-640-26-732S315,983,315,983L0,680-.17,856S260,1063,347,1226c16.34,92.25,17,518,0,717-5.34,62.48-347,545-347,615v206s309.72-488.11,347-549C407,2117,470,2042,493,1923Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M0,441s602,718,651,750,87,60,164,57,1577-22,1577-22l607.89-760.09L3000,321s-881-79-1419-79S372,209,0,317l-.15,2.8C-3.9,392.26,0,441,0,441Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M0,1720s341-152,365-216,69-155,66-213c-19-80-18-92-27-112s-13-35-29-57C350.8,1088.72,0,751,0,751Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3000,1565s-235-93-250-103-18-18-23-46-6-47-6-65,22-270,22-270l257-237Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1777,1886.68s537-4.68,577-16.68,275-299,275-299l-830,32Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1205,1691s17,199,22,224,10,109,62,179,93,102,220,100,151-26,209-96,81-399,81-399Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1205,1667s19,122,80,158,390.74,19.67,424,12c78-18,114-191,114-191Z",
    transform: "translate(1.78)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M401,1541s-42-22-50-79-7-114,50-153,79-30,140-41,191-53,295-55,222,2,302,48c15,10,36,11,59,5,36-15,23-57,59-75,16-9,135-47,252-47s237,22,250,28,21,22,26,33,14,33,18,41,4,15,12,17,766,23,795,33,47,22,57,33,48,55,48,96c0,18.44-3,52-8,63s-13,20-17,32-19,23-23,27-47,51-76,56-531-8-602,15-114,76-189,81-557,8-583,0-21-16-26-32-6-43-25-64Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M401,1541s-42-22-50-79-7-114,50-153,79-30,140-41,191-53,295-55,222,2,302,48c15,10,36,11,59,5,36-15,23-57,59-75,16-9,135-47,252-47s237,22,250,28,21,22,26,33,14,33,18,41,4,15,12,17,766,23,795,33,47,22,57,33,48,55,48,96c0,18.44-3,52-8,63s-13,20-17,32-19,23-23,27-47,51-76,56-531-8-602,15-114,76-189,81-557,8-583,0-21-16-26-32-6-43-25-64Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1169,1478V1364a73.52,73.52,0,0,1-2-48c8-26,22-40,35-45,7-13,13.25-15.56,18.12-26.78S1241,1169,1244,1169s256-41,256-41l277,38,19.42,67.7s5.78,20.14,12.68,26.72S1831,1278,1835,1289s18,69,12,113-10,112-10,112-2,21-10,34-16.18,20.75-19,23c-5,4-16,10-25,13-7,11-67.65,43.93-77,48-23,10-138,8-169,9s-190,0-190,0-19,2-49-13-96-54-96-54-25-17-30-40-4-43-3-48A16.94,16.94,0,0,0,1169,1478Z",
    transform: "translate(1.78)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1278,3000s0-150,25-235,94-173,197-212,335-56,491,0c0-81,508-44,586-36s202,33,251,71,151,230,172,350v62Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1147,3000s28-128,24-214-1-131-81-157-111-39-147-58-457.21-39.64-616.11,12.68S0,3000,0,3000Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M0,357S500,226,1500,237,3000,355,3000,355V0H0Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1248.78,
    y: 1296,
    width: 512,
    height: 233
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1091.5,1426.5c-5-10-99-211-328-200-226.62,10.89-338,219-338,219s-71,99-59,254c8.17,105.49,70,201,165,245s276,70,443-77S1145.5,1530.5,1091.5,1426.5ZM763.05,1296.36c192-9.14,270.86,158,275,166.3,10.22,19.52,15.74,44.48,17,72.41-12.92,7.08-30.94,15.91-43.07,17.93-18,3-55-22-55-22s-76-49-165-56-162,25-175,30-82,39-110,37-33-13-39-30c-1.92-5.43.76-14.63,5.29-24.64,3.86-5.83,6.33-8.91,6.33-8.91S573,1305.41,763.05,1296.36Zm-332,399.32c3.62-19,17-29.57,21.91-31.68,7-3,67-25,88,47s83,89,96,103c20.39,22,14,72,6,83-3.18,4.38-8.58,8.59-13.93,12.09a273.53,273.53,0,0,1-45.57-15.59C535.48,1872.09,447.64,1793.26,431.09,1695.68ZM933,1828c-55.81,44.08-110.1,69.08-160.27,80.93-10.32-20.33-40-107,23.27-135.93,81-37,111-91,120-103s66-37,98-33c14.74,1.84,3,51,10,59.66C1003,1748,972,1795.64,933,1828Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M454,1522s-14.38,22.84-11.19,50.42S458,1604,467,1608s62-2,83,32,44,116,137,114,182-87,203-131c39-34,48-11,75-11s90-17.93,90-36v-44l-358-69Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M475,1500s-24,7-21,22,10,29,29,31,36,6,94-21,109-42,146-43,150,9,200,45,75,40,87,38,45-31,45-31l-.64-10.78L1002,1503l-302-70Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M431,1433l23-68,162.76-114.54L795,1207l198,54,113,158,16,64s-30-49-50-74-57.75-98.67-135-133c-45-20-124-47-209-35s-164,63-208,102C486.13,1373,459,1406,431,1433Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M432.5,1690.08S428,1694,428,1708s35,110.09,73,142,94,67,120,67c15-13,20-23,20-23Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M773,1900s0,17,3,19,71-22,101-38,94-71,110-92,50-70,49-94-6-54-12-55-22,0-22,0Z",
    transform: "translate(1.78)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "personnages"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M144.75,1819.81s13.47-312.08-6.73-381.68-39.3-259.33-55-344.64c0-134.72,95.87-302,206.56-346.89,130.22-52.76,290.75-40.41,368.21,26.94S780.15,933,782.39,985.72s19,479.19,1,519.6-32.55,43.78-65.11,47.15-155.92,17-155.92,17L550,1819.81Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1025.3,1488.1s-64.14-28.87-64.14-54.52,14.8-55.73,14.8-55.73,22.88,32.07,44,21.52c19.25-9.63-25-95.37-25-95.37s1.43-30.78,25-34,119.74,54.52,123,85.52,5.55,79.11,5.55,79.11l-48.32,48.11Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1055,3000l36-384s-20.78-243.42-98-271c-84-30-344,0-344,0l262,655Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M775,1831.27s224.5-128.29,233.06-170S1015,1517,1015,1517s-8-76,49-91c41-10.78,91.59.09,101.21,26.82s111.18,243.75,87.66,375.24S923.6,2276,923.6,2276Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M0,1710c68.12-10.09,145.87-19.29,145.87-19.29s-13.47,46,30.31,66.24,317.7,33.67,354.75,19.08,20.2-30.31,20.2-30.31S751.27,1763.49,797,1813c109,118,116.77,358.72,124,419,9,75,12,319,12,487,0,109.76,13,281,13,281H0S-1,1793,0,1710Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M83,1730c18,40.42,174,101,287.38,89.81s233.51-15.71,253.71-38.17,25.07-21.16,25.07-21.16-29.56-79.87-67.73-91.1-108.89,20.21-227.88,35.93c-26.81,3.54-233.51,7.85-204.46-68.38C129,1651.42,65.05,1689.59,83,1730Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M83,1093.49s-32.56-11.23-40.42-53.89,0-52.76,20.21-64c-15.72-25.82-12.35-35.92-1.12-44.9C50.45,922.85,28,874.58,76.27,851c0-21.33,16.84-32.55,31.44-23.57C101,783.65,122.3,759,159.34,759c-6.73-20.21,18-53.89,49.4-56.13,0-24.7,29-71.29,72.31-56.41,14.13-42.38,65.77-43.5,89.34-34.52,0-22.45,59.5-55,88.69-29.19C472.55,567,527.56,546.78,564.61,604c41.53-22.45,87.56-25.82,104.4,32.56,0,0,59.5-12.35,60.62,50.51,33.68-3.37,52.76,70.73,28.06,80.83,48.28,21.33,34.8,62.87,25.82,78.58,34.8,14.6,33.68,62.87,19.09,83.08C826.17,961,777.9,988,777.9,988s-1.12,44.91-46,84.2c0,0-74.09,26.94-143.69,11.22C546.26,1073.92,163.84,1206.87,83,1093.49Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M83,1093.49C80.5,1090.84,118,1354,132,1415c14,40,15.13,96.47,15.36,106.76,41.17-.56,284.78,75.78,336.42,15.16,32.55-75.22,124.61-117.88,119-197.58s12.35-171.76,78.59-170.64c21.33,14.59,21.33,57.25,21.33,57.25s0,24.7,24.69,0c0-42.66-12.35-88.6,12.35-111.13s0-75.11,0-75.11Z",
    transform: "translate(1.78)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterieurVoiture);
export default __webpack_public_path__ + "static/media/interieur_voiture.812b8bdb2184c4a57964f15f00014dd7.svg";
export { ForwardRef as ReactComponent };